import { useBreakpoint } from '../../providers';
import { usePlacesAutocomplete } from '../../hooks/usePlacesAutoComplete';
import { Caption1, H5, H6 } from 'rwl-ui';
import styled from 'styled-components6';
import { When } from 'react-if';
import { useMapContext } from '../../hooks/MapProvider';

const Location = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LocationTitle = () => {
    const { clearSelectedPlaceId } = usePlacesAutocomplete();
    const { isBelowBreakpoint } = useBreakpoint();
    const { neighborhood, setNeighborhood } = useMapContext();

    return (
        <Location>
            {!!neighborhood?.postcode && (
                <H5 style={{ fontWeight: '700' }}>
                    Our work in {neighborhood?.postcode}
                </H5>
            )}
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <When condition={!!neighborhood?.neighborhood}>
                    <H6
                        style={{
                            fontWeight: '500',
                            color: 'var(--rwl-text-hint)',
                        }}
                    >
                        {neighborhood?.neighborhood}
                    </H6>
                </When>
                <When condition={isBelowBreakpoint('sm')}>
                    <Caption1
                        onClick={() => {
                            clearSelectedPlaceId();
                            setNeighborhood(undefined);
                        }}
                        style={{
                            textDecoration: 'underline',
                            marginLeft: 'var(--rwl-spacing-sm)',
                            cursor: 'pointer',
                        }}
                    >
                        Clear
                    </Caption1>
                </When>
            </div>
        </Location>
    );
};
